import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import {RiDeleteBin6Line} from 'react-icons/ri'

import { useCurrent,useFetch, usePost } from '../../hooks';
import { MwButton, MwInputText, MwSelector, MwSelectorProduct, MwSpinnerButton } from '../../components/ui';
import CardHeadeWithActions from '../../components/ui/CardHeadeWithActions';
import ImportExcel from './components/ImportExcel';
import { useTranslation } from 'react-i18next';

const ShowStockTaking = () => {
    const [t] = useTranslation('global');
    const params = useParams();
    const [stockTakingMaster,setStockTakingMaster] = useState();
    const [productInput,setProductInput] = useState('');
    const [stockTakingList,setStockTakingList] = useState([]);
    const [stockBalance,setStockBalance] = useState(0);
    const [systemBalance,setSystemBalance] = useState(0);
    const [pricePurchase,setPricePurchase] = useState();
    const [priceSale,setPriceSale] = useState();
    const {currentTenantId,currentCompanyId,currentBranchId,currentLangId,userId} = useCurrent();
    const [haveUom,setHaveUom] = useState();
    const [uomList,setUomList] = useState([]);
    const [uomSaleSelected,setUomSaleSelected] = useState();
    const {data:uomData,loading:uomLoading,fetchData} = useFetch(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/inventory/uom/${haveUom}`,false);
    const {data:warehoseSummaryResult,loading:warehoseSummaryLoading,fetchData:getPorductSummary} = useFetch(`${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/summary/product/${stockTakingMaster?.id}/${productInput?._id}`,false)
    const {data:stockTakingMasterResult,loading:loadingStockTakingMaster} = useFetch(`${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/stocktaking/master/${params?.id}`)
    const {data:resultPost,loading:loadingPost,postData} = usePost();
    const {data:allProductResult,loading:allProductLoading,postData:getproductPost} = usePost();
    const {data:resultPostRequisition,loading:loadingPostRequisition,postData:postRequisition} = usePost();
    
    const submitRequisition = () =>{
        console.log(stockTakingMaster,stockTakingList)
        if(!stockTakingMaster) return;
        const _url = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/requisitions/master`
        const _items = stockTakingList.map((item) =>({
            product_id : item?.product_id,
            product_name: item?.product_name,
            product_uom_id : item?.uom_id,
            product_uom_name : item?.uom_name,
            product_uom_template_id : item?.uom_template_id || 0,
            qty : item?.stock_balance,
            balance_before : item?.system_balance || 0,
            balance_after : item?.balance || 0,
            total : item?.stock_balance * item?.price_purchase
        }))
        const _data = {
            warehouse_id : stockTakingMaster?.warehouse_id,
            warehouse_id_to : null,
            req_type : "PASH", // 'PASH','PULL','TRANS'
            req_no: "stk-tkg-"+stockTakingMaster?.id ,
            req_note: "From Stock Takings" ,
            req_attach: "" ,
            req_status: 1 ,
            req_date : new Date().toISOString(),
            tenant_id : currentTenantId,
            company_id : currentCompanyId,
            branch_id : currentBranchId,
            created_by : userId,
            items : _items
        }
        postRequisition(_url,_data)
        console.log("_data",_data)
    }

    const getAllProducts = () =>{
        getproductPost(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/search/All`,{
            tenantId: currentTenantId,
            companyId: currentCompanyId
        })
    }

    useEffect(() => {
        if(resultPostRequisition){
            console.log('resultPostRequisition',resultPostRequisition)
        }
    },[resultPostRequisition])

    useEffect(() => {
        if(allProductResult){
            console.log("_list",allProductResult)

            let _list =[];
            allProductResult.data.map((product) => {
                _list.push({
                    product: product,
                    uom: {
                        label: product?.uomPurchase?.short_name?.trim(),
                        value: product?.uomPurchase?.id
                    },

                    pricePurchase: product?.cost,
                    priceSale: product?.price,
                    stockBalance :  0,
                    systemBalance : product?.qty || 0,
                    balance :   product?.qty || 0
                })
            });
            console.log("_list",_list)
            setStockTakingList(_list);
        }
    },[allProductResult]);
    
    useEffect(() => {
        if(uomSaleSelected){
            console.log('uomSaleSelected',uomSaleSelected)
        }
    },[uomSaleSelected]);

    useEffect(() =>{
        if(haveUom){
            console.log('haveUom',haveUom)
            fetchData()
        }
    },[haveUom])

    useEffect(() => {
        console.log('setUomList',uomData);
                if(uomData  ){
                    let itemList = [];
                    uomData?.data?.uom_master?.uom_details.map((el)=>itemList?.push({label:el?.short_name?.trim(),value:el?.id,lang:currentLangId,data:el}));
                    setUomList(itemList)
                    console.log('setUomList',itemList)
                }
            },[uomData]);

    useEffect(()=>{
        if(stockTakingMasterResult){
            setStockTakingMaster(stockTakingMasterResult.data)
            if(stockTakingMasterResult?.data?.details?.length > 0){
                setStockTakingList(stockTakingMasterResult?.data?.details)
                console.log("stockTakingMaster",stockTakingMasterResult,stockTakingList)
            }
        }
    },[stockTakingMasterResult]);

    useEffect(()=>{
        console.log("warehoseSummaryResult",warehoseSummaryResult)
        if(warehoseSummaryResult){
            const _balance = (warehoseSummaryResult.come_purchase_qty || 0 + warehoseSummaryResult.come_return_qty || 0 + warehoseSummaryResult.come_trans_qty || 0 + warehoseSummaryResult.come_req_qty || 0) - (warehoseSummaryResult.out_sales_qty || 0 + warehoseSummaryResult.out_return_qty || 0 + warehoseSummaryResult.out_trans_qty || 0 + warehoseSummaryResult.out_req_qty || 0);
            setSystemBalance(_balance);
        }else{
            setSystemBalance(0)
        }
    },[warehoseSummaryResult]);

    const onchangeProduct = (product) =>{
        setUomList([])
        if(product?.uomTemplate?.id){
            setHaveUom(product?.uomTemplate?.id)
            setUomSaleSelected({label:product?.uomSale?.short_name?.trim(),value:product?.uomSale?.id,lang:currentLangId,data:product?.uomSale})

        }
        setProductInput(product)
        stockTakingMaster && productInput?._id && getPorductSummary()
        console.log("onchangeProduct",product);
    }
    const addToList = () =>{
        if(!productInput?._id){
            return
        }
        setUomList([])
        const _list = [...stockTakingList,{
            product: productInput,
            uom:uomSaleSelected,
            pricePurchase:pricePurchase,
            priceSale:priceSale,
            stockBalance :stockBalance || 0,
            systemBalance : systemBalance || 0,
            balance :   systemBalance - stockBalance
        }]
        setStockTakingList(_list);
        restFrom();
        console.log("addToList",_list);
    }

    const restFrom = () =>{
        console.log("restFrom");
        setProductInput(null)
        setStockBalance(0);
        setSystemBalance(0);
    }

    useEffect(() =>{
        if(resultPost){
            console.log("resultPost",resultPost);
        }
    },[resultPost])
    const deleteHandeler = (index) =>{
        const _list = stockTakingList.filter((item,i) => i !== index);
        console.log("stockTakingList new",index,_list);
        setStockTakingList(_list);
    }
    const submitHandler = () =>{
        const _dataItems = stockTakingList?.map(item => ({
            stocktaking_id : stockTakingMaster?.id,
            product_id : item?.product?._id || item?.product_id || "0",
            product_name : item?.product?.productName[0]?.text || item?.product?.productName[1]?.text || item?.product_name,
            uom_id : item?.product?.uomPurchase?.id ||  item?.uom_id || 0,
            uom_name : item?.product?.uomPurchase?.short_name || item?.uom_name || "",
            uom_template_id : item?.product?.uomTemplate?.id || item?.uom_template_id || 0,
            price_purchase: item?.pricePurchase || item?.price_purchase || '',
            price_sale: item?.priceSale || item?.price_sale || '',
            stock_balance: item?.stockBalance || item?.stock_balance || 0,
            system_balance: item?.systemBalance || item?.stock_balance || 0,
            balance : Math.abs(item?.balance) || 0,
        }))

        console.log('submit data : ',_dataItems)
        const _url = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/stocktaking/details`;
        postData(_url, {items:_dataItems});
    }
    const excelImportResult = (newValue) => {
        setStockTakingList([...stockTakingList,...newValue])
        console.log(newValue);
    }
    const onChangeList = (index,name,value) => {
        // stockTakingList[index] = {...stockTakingList[index],[name]:value};
        stockTakingList[index] =  {...stockTakingList[index],[name]:value};
        stockTakingList[index] =  {...stockTakingList[index], balance: Math.abs((stockTakingList[index]?.stockBalance || 0)  - (stockTakingList[index]?.systemBalance || 0) ).toString()};
        
        setStockTakingList([...stockTakingList]);
    }
    return (
<div className='flex flex-col gap-3  h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar text-[#251658]'>
      <CardHeadeWithActions
        title={
          <div className='flex flex-col gap-1'>
            <span className='text-lg font-bold'>{t('stocktaking.warehouse_inventory')}</span>
            <div className='text-sm font-medium text-[#251658]'>
              {stockTakingMaster?.code ? `${stockTakingMaster?.code} • ${stockTakingMaster?.warehouse?.name_ar || stockTakingMaster?.warehouse?.name_en}` : t('stocktaking.inventory_code')}
            </div>
          </div>
        }
      >
        <div className='flex  flex-wrap items-center gap-2 justify-left'>
            {allProductLoading ? (
              <MwSpinnerButton withLabel={false} />
            ) : (
              <MwButton onClick={()=>getAllProducts()} disabled={stockTakingMaster?.completed} type="secondary">
                {t('stocktaking.add_all_products')}
              </MwButton>
            )}
          <div className=''>
            {loadingPostRequisition ? (
              <MwSpinnerButton withLabel={false} />
            ) : stockTakingMasterResult?.data?.details?.length > 0 ? (
              <MwButton disabled={stockTakingMaster?.completed} onClick={()=>submitRequisition()} type="saveBtn">
                {t('stocktaking.inventory_settlement')}
              </MwButton>
            ) : (
              <div />
            )}
          </div>
        </div>
      </CardHeadeWithActions>

      <div className='flex gap-2 w-[98%] mx-auto items-center border border-gray-200 bg-white p-4 rounded-2xl'>
                <div className='flex-1'>
                    <ImportExcel callbackImported = {excelImportResult}/>
                </div>
            </div>
            <div className='flex gap-2 items-center  w-[98%] mx-auto  bg-slate-200 p-4 rounded-2xl '>
                <div className='relative flex-1'>
                    <MwSelectorProduct 
                        withLabel = {true}
                        onChangeCallback ={onchangeProduct}
                        initalValue = {productInput}
                        />
                </div>
                {
                    uomList.length > 0 && 
                    <div className='w-28'>
                            <MwSelector
                                    label='الوحدة'
                                    initalValue='أختار..'
                                    dataType = 'labelValue'
                                    _data={uomList}
                                    withAddNew = {false}
                                    selectedItem={uomSaleSelected}
                                    setSelectedItem={setUomSaleSelected}
                                    withSearch={false}
                                />
                    </div>
                }

                <div className='w-28'>
                    <MwInputText
                        label ={t('stocktaking.purchase_price')}
                        value ={productInput?.cost}
                        onChange={(e)=>setPricePurchase(e.target.value)}
                        // disabled={true}
                        />
                </div>
                <div className='w-28'>
                    <MwInputText
                        label ={t('stocktaking.sale_price')}
                        value ={productInput?.price}
                        onChange={(e)=>setPriceSale(e.target.value)}
                        // disabled={true}
                        />
                </div>
                <div className='w-32'>
                    <MwInputText
                        label ={t('stocktaking.warehouse_quantity')}
                        value ={stockBalance}
                        onChange = {(e) => setStockBalance(e.target.value)}
                        />
                </div>
                <div className='w-28'>
                    <MwInputText
                        label ={t('stocktaking.system_quantity')}
                        value ={systemBalance}
                        disabled={true}
                        />
                </div>
                <div className='w-28'>
                    <MwInputText
                        label ={t('stocktaking.shortage_increase')}
                        value = {Math.abs(systemBalance - stockBalance)}
                        disabled={true}
                        />
                </div>
                <div className='pt-6'>
                    <MwButton onClick={addToList} disabled={!productInput?._id} type='saveBtn'>{t('stocktaking.add')}</MwButton>
                </div>
            </div>
            {
                resultPost?.status === 1 && 
                <div className='bg-green-300 text-green-800 p-2 rounded-xl flex items-center justify-center'>
                   <span>  {t('stocktaking.inventory_upload_success')}      </span>
                </div>
            }
            {
                stockTakingMaster?.completed && 
                <div className='bg-red-300 text-red-800 p-2 rounded-xl flex items-center justify-center'>
                   <span>  {t('stocktaking.inventory_settlement_message')} </span>
                </div>
            }
            {
                stockTakingList.length > 0 &&
                <div>
<div className='flex  w-[98%] mx-auto  flex-col text-[#251658] max-h-[calc(100vh-250px)] overflow-y-auto'>                        <div className='flex justify-between items-center font-bold text-sm gap-5 border w-full p-2 bg-slate-100 rounded-t-2xl'>
                            <div className='flex-1 text-center'> {t('stocktaking.product')} </div>
                            <div className='w-28 text-center'>  {t('stocktaking.unit')} </div>
                            <div className='w-28 text-center'>   {t('stocktaking.purchase_price')}   </div>
                            <div className='w-28 text-center'>   {t('stocktaking.sale_price')}   </div>
                            <div className='w-32 text-center'>  {t('stocktaking.warehouse_quantity')}   </div>
                            <div className='w-28 text-center'>  {t('stocktaking.system_quantity')}  </div>
                            <div className='w-28 text-center'>  {t('stocktaking.shortage_increase')} </div>
                            <div className='w-8 text-center'></div>
                        </div>
                        {
                            stockTakingList.length > 0 ? 
                                stockTakingList?.map((item,index) => 
                                        <div key={index} className='flex justify-between items-center gap-5 border w-full p-2 bg-slate-100 min-h-[60px]'>
                                            <div className='flex flex-1'>
                                                <div className='flex items-center justify-center w-28 font-bold'>{index +1 }</div>
                                                <div className='flex gap-5'>
                                                    <div>
                                                        <div className='font-bold'>{item.product?.productName.length > 0 ? item.product?.productName[0]?.text : item.product_name }</div>
                                                        <div  >{item.product?.productName[1] && item.product?.productName[1]?.text}</div>
                                                    </div>
                                                    <div className='flex-1 flex gap-4 py-1 text-sm items-center justify-center'>
                                                        <div className='flex-1 flex gap-2 h-6 items-center justify-center'>
                                                            { item.product?.productBrand?.brandName?.length > 0 && <div className='rounded-lg bg-slate-400 px-2'>{ item.product?.productBrand?.brandName[0]?.text}</div> }
                                                            { item.product?.productBrand?.brandName?.length > 0 && <div className='rounded-lg bg-slate-400 px-2'>{ item.product?.productBrand?.brandName[1]?.text}</div> }
                                                        </div>
                                                        {/* <div  className='flex-1 flex gap-2 h-6 items-center justify-center'>
                                                            { item.product?.productCategory[0]?.categoryName?.length > 0 && <div className='rounded-lg bg-slate-300 px-2'>{item.product?.productCategory[0]?.categoryName[0]?.text}</div> }
                                                            { item.product?.productCategory[0]?.categoryName?.length > 0 &&  <div className='rounded-lg bg-slate-300 px-2'>{item.product?.productCategory[0]?.categoryName[1]?.text}</div> }
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='w-28 font-bold text-center'>{item?.uom?.label || item?.uom_name }</div>
                                            <div className='w-28 font-bold text-center'>
                                                <MwInputText
                                                    disabled={stockTakingMaster?.completed}
                                                    value = {item?.pricePurchase || item?.price_purchase  }
                                                    onChange={(e)=>{ onChangeList(index,"pricePurchase",e.target.value)}}
                                                    />
                                            </div>
                                            <div className='w-28 font-bold text-center'>
                                                <MwInputText
                                                    disabled={stockTakingMaster?.completed}
                                                    value = {item?.priceSale || item?.price_sale  }
                                                    onChange={(e)=>{ onChangeList(index,"priceSale",e.target.value)}}
                                                    />
                                            </div>
                                            <div className='w-28 font-bold text-center'>
                                                <MwInputText
                                                    disabled={stockTakingMaster?.completed}
                                                    value = {item?.stockBalance || item?.stock_balance || 0  }
                                                    onChange={(e)=>{ onChangeList(index,"stockBalance",e.target.value)}}
                                                    />
                                            </div>
                                            <div className='w-28 font-bold text-center'>
                                                <MwInputText
                                                    disabled={true}
                                                    value = { stockTakingList[index]?.systemBalance   }
                                                    />
                                                {/* {item.systemBalance || item?.system_balance || 0 } */}
                                                </div>
                                            <div className='w-28 font-bold text-center'>
                                                <MwInputText
                                                    disabled={true}
                                                    value = { stockTakingList[index]?.balance   }
                                                    />
                                            </div>
                                            { stockTakingMaster?.completed ? <div className='w-8 ' > </div> : <div className='w-8 text-center text-[#251658] cursor-pointer hover:text-[#251658]/80' onClick={()=>deleteHandeler(index)}><RiDeleteBin6Line size={18} /></div> }
                                        </div>)
                                :
                                <div></div>
                        }
                    </div>
                    <div className='flex flex-row-reverse   w-[98%] mx-auto  my-2'>
                        { loadingPost ? <MwSpinnerButton withLabel={false} /> :<MwButton onClick={submitHandler} disabled={stockTakingMaster?.completed}  type='saveBtn' >   {t('stocktaking.approve_inventory')}</MwButton>}
                    </div>
                </div>
            }
            
        </div>
    )
}

export default ShowStockTaking